import RegistrationForm from "./RegistrationForm/RegistrationForm";
(function () {
    new RegistrationForm();
})();
